import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import { get } from 'lodash';
import React from 'react';
import DragNDropColumns from 'src/components/DragNDropColumns';
import { Field } from 'src/components/RcForm';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { products } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { useSalesChannelWithSisterProductSelectionUuid } from 'src/hooks/useSalesChannelWithSisterProductSelectionUuid';

const Products = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    draggableId,
    onSort,
    onDelete,
    onReselect,
    disabled,
    disableDeleteText,
    salesChannelUuid,
  } = props;
  const valueWithDraId = (value || []).map((i) => {
    return {
      ...i,
      draggableId: i.uuid,
    };
  });

  const [visible, setVisible] = React.useState(false);
  const handleOnItemReselect = (products) => {
    if (onReselect) {
      onReselect(valueWithDraId, onChange, products);
    }
  };
  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    if (onSort) {
      onSort(valueWithDraId, onChange, oldIndex, newIndex);
    }
  };
  const handleOnItemDelete = (index) => {
    if (onDelete) {
      onDelete(valueWithDraId, onChange, index);
    }
  };
  const childGenerate = (data, index) => {
    const sku = get(data, 'sku');
    const name = get(data, 'productName');
    const thumbnailUrl = get(data, 'thumbnailUrl');
    return <ProductDisplayInRow sku={sku} name={name} img={thumbnailUrl} />;
  };

  return (
    <React.Fragment>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={() => {
            setVisible(false);
          }}
          onOk={handleOnItemReselect}
          selectedProducts={valueWithDraId || []}
          disabledProducts={[]}
          salesChannelUuid={salesChannelUuid}
          // salesChannelUuid
        />
      )}
      <DragNDropColumns
        disabled={disabled}
        hideAdd={disabled}
        disableAddText={disabled}
        hideTitle
        childGenerate={childGenerate}
        data={valueWithDraId || []}
        droppableId={`salesChannelContentListProductCarousel${draggableId}`}
        onSort={handleItemOnSort}
        // hideAdd={hideAdd}
        onAdd={() => {
          setVisible(true);
        }}
        addText={`+ ${getI18n('general.addProduct')}`}
        onDelete={handleOnItemDelete}
        disableDeleteText={disableDeleteText}
      />
    </React.Fragment>
  );
};

const ProductsWithField = (props) => {
  const { draggableId, moduleType, breakpoint, ...p } = props;
  return (
    <Field name={products}>
      {(props, meta) => (
        <Products
          id={`${get(meta, 'name').join('_')}_${draggableId}`}
          draggableId={draggableId}
          moduleType={moduleType}
          breakpoint={breakpoint}
          {...props}
          {...meta}
          {...p}
        />
      )}
    </Field>
  );
};

const ProductsFieldWithSisterSalesChannelSelect = (props) => {
  const salesChannelUuid = useSalesChannelWithSisterProductSelectionUuid();

  return <ProductsWithField salesChannelUuid={salesChannelUuid} {...props} />;
};

export default ProductsFieldWithSisterSalesChannelSelect;
